export default "__VITE_ASSET__C8ZxzPnP__"